import api from "./api";

export const authService = {
  /**
   * =====================================================
   * REGISTER CANDIDATE
   * =====================================================
   */
  register: (payload) =>
    api
      .post("/auth/register", payload)
      .then((r) => r.data),

  /**
   * =====================================================
   * CANDIDATE LOGIN
   *
   * Backend expects:
   * {
   *   identifier: email OR phone,
   *   password
   * }
   *
   * This supports both:
   * {
   *   identifier,
   *   password
   * }
   *
   * and old frontend:
   * {
   *   email,
   *   password
   * }
   * =====================================================
   */
  login: (payload = {}) => {
    const identifier =
      payload.identifier ||
      payload.email ||
      payload.phone ||
      "";

    return api
      .post("/auth/login", {
        identifier: identifier.trim(),
        password: payload.password || "",
      })
      .then((r) => r.data);
  },

  /**
   * =====================================================
   * ADMIN LOGIN
   * =====================================================
   */
  adminLogin: (payload = {}) =>
    api
      .post("/auth/admin/login", {
        email: payload.email || "",
        password: payload.password || "",
      })
      .then((r) => r.data),

  /**
   * =====================================================
   * CURRENT LOGGED-IN USER
   * =====================================================
   */
  me: () =>
    api
      .get("/auth/me")
      .then((r) => r.data),

  /**
   * =====================================================
   * VERIFY EMAIL OTP
   * =====================================================
   */
  verifyEmail: (otp) =>
    api
      .post("/auth/verify-email", {
        otp,
      })
      .then((r) => r.data),

  /**
   * =====================================================
   * RESEND EMAIL OTP
   * =====================================================
   */
  resendEmailOTP: () =>
    api
      .post("/auth/verify-email/resend")
      .then((r) => r.data),

  /**
   * =====================================================
   * FORGOT PASSWORD - SEND OTP
   * =====================================================
   */
  forgotPassword: (email) =>
    api
      .post("/auth/forgot-password", {
        email,
      })
      .then((r) => r.data),

  /**
   * =====================================================
   * FORGOT PASSWORD - VERIFY OTP
   * =====================================================
   */
  verifyForgotPasswordOTP: (email, otp) =>
    api
      .post("/auth/forgot-password/verify-otp", {
        email,
        otp,
      })
      .then((r) => r.data),

  /**
   * =====================================================
   * FORGOT PASSWORD - RESEND OTP
   * =====================================================
   */
  resendForgotPasswordOTP: (email) =>
    api
      .post("/auth/forgot-password/resend", {
        email,
      })
      .then((r) => r.data),

  /**
   * =====================================================
   * RESET PASSWORD
   * =====================================================
   */
  resetPassword: (
    email,
    resetToken,
    newPassword
  ) =>
    api
      .post("/auth/forgot-password/reset", {
        email,
        resetToken,
        newPassword,
      })
      .then((r) => r.data),
};